import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import API from "../../../Common/API";
import { motion } from "framer-motion";
import profession from "../../../Assets/Icons/profession.svg";
import income from "../../../Assets/Icons/income.svg";
import date from "../../../Assets/Icons/date.svg";
import stars from "../../../Assets/Icons/star.svg";
import workLocation from "../../../Assets/Icons/workLocation.svg";
import flawsIcon from "../../../Assets/Icons/flaws.svg";
import { FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import RasiKattam from "../../../Components/RasiKattam";
import AmsaKattam from "../../../Components/AmsaKattam";
import Button from "../../../Components/Button";
import PreviewProfileLoader from "../../../Components/Loaders/PreviewProfileLoader";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../../Store/Theme/actions";
import Dialog from "../../../Components/Dialog";
import { setCountApi } from "../../../Store/Auth/actions";
import { useTranslation } from "react-i18next";
import dummy from "../../../Assets/Images/dummy.jpg.webp";
import { useHistory } from "react-router-dom";
import html2pdf from "html2pdf.js";
import PrintUser from "./PrintUser";

const PreviewUser = ({ userValues, registration = false }) => {
  const userDetails = userValues;
  const loggedInUser = useSelector((state) => state.auth.userDetails);
  const educationList = useSelector((state) => state.auth.educationList);
  const zodiacSigns = useSelector((state) => state.auth.zodiacSigns);
  const flaws = useSelector((state) => state.auth.flaws);
  const occupation = useSelector((state) => state.auth.fullOccupations);
  const allStars = useSelector((state) => state.auth.allStars);
  const status = useSelector((state) => state.auth.status);
  const tStatus = useSelector((state) => state.auth.tStatus);
  const tFlaws = useSelector((state) => state.auth.tFlaws);
  const tOccupation = useSelector((state) => state.auth.tOccupation);
  const [loading, setLoading] = useState(true);
  const countApi = useSelector((state) => state.auth.countApi);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const dispatch = useDispatch();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const lang = useSelector((state) => state.theme.language);
  const dhisas = useSelector((state) => state.auth.dhisa);
  const { t } = useTranslation();
  const history = useHistory();
  const ownId = useSelector((state) => state.auth.userDetails._id);

  const printRef = useRef();

  // const handlePrint = async () => {
  //     const element = printRef.current;

  //     // Create watermark overlay
  //     const watermark = document.createElement("div");
  //     watermark.textContent = "royalkavery";
  //     Object.assign(watermark.style, {
  //         position: "absolute",
  //         top: "40%",
  //         left: "20%",
  //         fontSize: "48px",
  //         color: "rgba(0,0,0,0.1)",
  //         transform: "rotate(-45deg)",
  //         pointerEvents: "none",
  //         zIndex: 9999,
  //         width: "100%",
  //         textAlign: "center",
  //         whiteSpace: "nowrap"
  //     });
  //     element.appendChild(watermark);

  //     const canvas = await html2canvas(element, {
  //         scale: 2,
  //         useCORS: true
  //     });

  //     element.removeChild(watermark); // Remove watermark from the DOM after capture

  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'pt', 'a4');
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     pdf.save("profile.pdf");
  // };

  useEffect(() => {
    try {
      // axios.all([API.get('/common/getEducations'), API.get('/common/getZodiacSign'), API.get('/common/getAllFlaws'), API.get('/common/getStatusList'), API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then((axios.spread((eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
      // setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
      // setFullEducations(eduRes.data.data)
      // setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
      // setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
      // setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
      // setOccupation(occuRes.data.data)
      // setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
      setLoading(false);
      // })))
    } catch (err) {
      console.log(err);
    }
  }, []);

  const calculateAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // If birth month is after current month or same month but birth date is after current date, subtract 1
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getFlaws = (value) => {
    if (lang === "en") {
      return flaws.filter((x) => x.value === value)[0].text;
    } else {
      return tFlaws.filter((x) => x.value === value)[0].text;
    }
  };

  const getStatus = (value) => {
    if (value.toString().length > 0) {
      if (lang === "en") {
        return status.filter((x) => x.value === value)[0].text;
      } else {
        return tStatus.filter((x) => x.value === value)[0].text;
      }
    }
    return null;
  };

  const getZodiac = (value) => {
    return zodiacSigns.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getStars = (value) => {
    return allStars.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const getQualification = (value) => {
    return educationList.filter((x) => {
      return x.value === value;
    })[0].text;
  };

  const downloadProfile = (value) => {
    setDownloadConfirm(true);
  };

  const confirmDownload = () => {
    setConfirmLoading(true);
    try {
      let apiValues = {
        profileId: userDetails._id,
        addedBy: loggedInUser._id,
      };
      API.post("/user/downloadProfile", apiValues)
        .then((apiRes) => {
          if (apiRes.status === 200) {
            userDetails.isDownloaded = true;
            dispatch(
              setAlert({
                title: "Success",
                subtitle: "Profile Downloaded Successfully",
                type: "success",
                active: true,
              })
            );
            setDownloadConfirm(false);
            setConfirmLoading(false);
            dispatch(setCountApi(countApi + 1));
          }
        })
        .catch((err) => {
          setConfirmLoading(false);
          dispatch(
            setAlert({
              title: "Error",
              subtitle: err.response.data.error,
              type: "error",
              active: true,
            })
          );
        });
    } catch (err) {
      dispatch(
        setAlert({
          title: "Error",
          subtitle: "Something went wrong",
          type: "error",
          active: true,
        })
      );
    }
  };

  const downloadPDF = (refId) => {
    const element = printRef.current;
    const opt = {
      margin: 0.5,
      filename: `${refId}Profile.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: `` },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  const getDhisas = (values) => {
    return values
      ? dhisas.filter((x) => {
          return x.value === parseInt(values);
        })[0].text
      : "-";
  };

  const formatTo12Hour = (time24) => {
    if (!time24) return "";

    const [hour, minute] = time24.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  };

  const handlePrint = () => {
    window.print();
  };

  const clearHeights = (height) => {
    let input = height;
    let cleaned = input.match(/\d+\s*ft\s*\d*\s*in/);
    return cleaned ? cleaned[0] : "--";
  };

  return (
    <>
      {loading ? (
        <PreviewProfileLoader />
      ) : (
        <motion.div
          id="printable-area"
          className="min-h-screen w-full flex flex-col relative px-2 sm:px-4 py-2 sm:py-4"
        >
          {/* Basic Profile Details */}
          {!registration && (
            <div className="no-print mb-4">
              <Button
                type={"primary"}
                injectClass={"h-fit rounded-full px-1 w-fit text-xs sm:text-sm"}
                onClick={() => history.goBack()}
              >
                {t("Back to search")}
              </Button>
            </div>
          )}
          <div className="print:block hidden text-start font-bold text-xl mb-8">
            <div ref={printRef}>
              <PrintUser userDetails={userDetails} />
            </div>
          </div>
          <div className="print:block hidden fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/2 -rotate-45 text-[80px] font-bold text-primeColor/10 pointer-events-none select-none z-0 whitespace-nowrap">
            Royal Kavery
          </div>
            <motion.div className="no-print flex flex-col gap-6 sm:gap-8">
              <motion.div className="flex flex-col md:flex-row justify-start gap-4 sm:gap-6">
              {!registration ? (
                <motion.div className="flex flex-col h-full gap-3 w-full sm:w-fit no-print">
                  <motion.div className="w-full sm:w-64">
                    {userDetails?.previewUrls && userDetails?.previewUrls[0] ? (
                      <img
                        src={
                          userDetails?.previewUrls.length > 0
                            ? userDetails?.previewUrls[0]?.imageUrl
                            : dummy
                        }
                        className="w-full h-auto max-h-64 sm:h-64 sm:w-64 object-contain rounded-lg"
                        alt="Preview"
                      />
                    ) : (
                      <img
                        src={dummy}
                        className="w-full h-auto max-h-64 sm:h-64 sm:w-64 object-cover rounded-lg"
                        alt="Preview"
                      />
                    )}
                  </motion.div>
                  <motion.div className="flex flex-row gap-2 w-full overflow-x-auto py-2">
                    <PhotoProvider>
                      {userDetails &&
                        userDetails.previewUrls.map((photo, index) => {
                          return (
                            <PhotoView key={index} src={photo?.imageUrl}>
                              <img
                                src={photo?.imageUrl}
                                alt=""
                                className="w-16 h-16 sm:w-20 sm:h-20 object-cover cursor-pointer rounded-lg flex-shrink-0"
                              />
                            </PhotoView>
                          );
                        })}
                    </PhotoProvider>
                  </motion.div>
                </motion.div>
              ) : (
                <motion.div className="flex flex-col h-full gap-3 w-full max-w-md">
                  <motion.div className="w-full">
                    {userDetails?.previewUrls &&
                      userDetails?.previewUrls[0] && (
                        <img
                          src={userDetails?.previewUrls[0]}
                          className="w-full h-auto max-h-96 object-cover rounded-lg"
                          alt="Preview"
                        />
                      )}
                  </motion.div>
                  <motion.div className="flex flex-row gap-2 w-full overflow-x-auto py-2">
                    {userDetails?.previewUrls &&
                      userDetails?.previewUrls.map((c, index) => {
                        return (
                          <img
                            key={index}
                            src={c}
                            className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg flex-shrink-0"
                            alt={"Preview"}
                          />
                        );
                      })}
                  </motion.div>
                </motion.div>
              )}
              <motion.div className="flex flex-col lg:flex-row justify-between w-full px-2 sm:px-5">
                <motion.div className="flex flex-col h-full w-full gap-3">
                  {lang === "en" ? (
                    <p className="text-lg sm:text-xl font-bold text-primeColor break-words">
                      {userDetails?.firstName}&nbsp;{userDetails?.lastName} (
                      {userDetails?.surname}){" "}
                    </p>
                  ) : (
                    <p className="text-lg sm:text-xl font-bold text-primeColor break-words">
                      {userDetails?.tFirstName}&nbsp;{userDetails?.tLastName} (
                      {userDetails?.tSurname}){" "}
                    </p>
                  )}
                  <p className="text-sm sm:text-base font-bold text-primeColor break-words">
                    {userDetails?.refId}
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm font-bold justify-start gap-2 items-center">
                    <img src={profession} alt="profession" className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="break-words">{userDetails?.occupationDetail || userDetails?.occupation}</span>
                    <span className="text-greyColor items-center font-bold text-xs sm:text-sm flex-shrink-0">
                      |
                    </span>
                    <span className="break-words">{calculateAge(userDetails?.dateOfBirth)} {t("Years Old")}</span>
                    <span className="text-greyColor items-center font-bold text-xs sm:text-sm flex-shrink-0">
                      |
                    </span>
                    <span className="break-words">
                      {!registration
                        ? clearHeights(userDetails?.heightInFeet)
                        : clearHeights(
                            `${userDetails?.heightInFeet.split(".")[0]} ft ${
                              userDetails?.heightInFeet.split(".")[1]
                            } in`
                          ) || "-"}
                    </span>
                  </p>
                  {!registration && (
                    <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                      <img src={date} alt="income" className="w-4 h-4 sm:w-5 sm:h-5" />
                      <span className="break-words">{t("Date Of Birth")}</span>
                      <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                        {userDetails?.date +
                          "/" +
                          userDetails?.month +
                          "/" +
                          userDetails?.year}
                      </span>
                    </p>
                  )}
                  {registration && (
                    <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                      <img src={date} alt="income" className="w-4 h-4 sm:w-5 sm:h-5" />
                      <span className="break-words">{t("Date Of Birth")}</span>
                      <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                        {userDetails?.dateOfBirth.split("-")[2] +
                          "/" +
                          userDetails?.dateOfBirth.split("-")[1] +
                          "/" +
                          userDetails?.dateOfBirth.split("-")[0]}
                      </span>
                    </p>
                  )}
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <img src={income} alt="income" className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="break-words">{t("Income")}/
                    {userDetails?.salaryMode
                      ? t(`${userDetails?.salaryMode}`)
                      : "Month"}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {userDetails?.salary}
                    </span>
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <FaGraduationCap className="mx-1" size={16} />
                    <span className="break-words">{t("Qualification")}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {userDetails?.otherEducationalQualification}
                    </span>
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <img
                      src={workLocation}
                      alt="building"
                      className="w-4 h-4 sm:w-5 sm:h-5"
                    />
                    <span className="break-words">{t("Work Location")}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {userDetails?.occupationLocation || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <TbZodiacCancer className="mx-1" size={16} />
                    <span className="break-words">{t("Zodiac Sign")}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {
                        zodiacSigns?.filter(
                          (x) =>
                            x.value ===
                            userDetails?.additionalInformation?.zodiacSign
                        )[0].text
                      }
                    </span>
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <img
                      src={stars}
                      alt="workLocation"
                      className="w-4 h-4 sm:w-5 sm:h-5"
                    />
                    <span className="break-words">{t("Star")}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {userDetails?.additionalInformation?.star
                        ? allStars?.filter(
                            (x) =>
                              x.value ===
                              userDetails?.additionalInformation?.star
                          )[0]?.text
                        : "-"}
                    </span>
                    <span className="text-primeColor font-bold text-xs sm:text-sm break-words">
                      {userDetails?.additionalInformation?.padham || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row flex-wrap text-xs sm:text-sm justify-start gap-2 items-center">
                    <img
                      src={flawsIcon}
                      alt="flaws"
                      className="w-4 h-4 sm:w-5 sm:h-5"
                    />
                    <span className="break-words">{t("Flaws")}</span>
                    <span className="text-primeColor items-center font-bold text-xs sm:text-sm break-words">
                      {userDetails?.additionalInformation?.flaws?.length > 0
                        ? userDetails?.additionalInformation?.flaws?.map((c, i) => {
                            return (
                              <span key={i}>
                                {getFlaws(c)}
                                {i !== userDetails?.additionalInformation?.flaws?.length - 1 && ", "}
                              </span>
                            );
                          })
                        : "-"}
                    </span>
                  </p>
                </motion.div>
                {!registration && (
                  <motion.div className="no-print flex flex-col sm:flex-row gap-3 justify-center sm:justify-end w-full h-full">
                    {!userDetails?.isDownloaded && userDetails?._id !== ownId && (
                      <motion.div
                        className="flex flex-row items-center text-sm w-full sm:w-fit"
                        onClick={() => downloadProfile(userDetails)}
                      >
                        <Button type={"primary"} injectClass={"w-full sm:w-fit px-4 py-2 min-h-[44px]"}>
                          {t("View Contact Information")}
                        </Button>
                      </motion.div>
                    )}
                    <motion.div
                      className="flex flex-row items-center text-sm w-full sm:w-fit"
                      onClick={() => handlePrint()}
                    >
                      <Button type={"primary"} injectClass={"w-full sm:w-fit px-4 py-2 min-h-[44px]"}>
                        {t("Print Profile")}
                      </Button>
                    </motion.div>
                    {/* <motion.div className="flex flex-row items-center" onClick={() => downloadPDF(userDetails.refId)}>
                                        <Button type={'primary'} injectClass={'w-fit'}>{t('Download Profile')}</Button>
                                    </motion.div> */}
                  </motion.div>
                )}
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-col lg:flex-row flex-wrap justify-start gap-4 sm:gap-6 px-2 sm:px-5 w-full my-6 sm:my-8">
              {/* Family Information */}
              <motion.div className="flex flex-col gap-5 w-full lg:w-fit px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Family Information")}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Father name")}</p>
                  {lang === "en" && (
                    <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                      {userDetails?.familyInformation?.fatherFirstName}&nbsp;(
                      {userDetails?.familyInformation?.fatherSurname})
                    </p>
                  )}
                  {lang === "ta" && (
                    <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                      {userDetails?.familyInformation?.tFatherFirstName ||
                        userDetails?.familyInformation?.fatherFirstName}
                      &nbsp;(
                      {userDetails?.familyInformation?.tFatherSurname ||
                        userDetails?.familyInformation?.fatherSurname}
                      )
                    </p>
                  )}
                  <p className="text-xs sm:text-sm font-medium">{t("Father Occupation")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.fatherOccupation || "-"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Father Native")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.fatherNative || "-"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Mother name")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.motherFirstName}&nbsp;(
                    {userDetails?.familyInformation?.motherSurname})
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Mother Occupation")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.motherOccupation || "-"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Mother Native")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.motherNative || "-"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Male Siblings")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.numberOfMaleSiblings}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Female Siblings")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.numberOfFemaleSiblings}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Married Male Siblings")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.marriedMaleSiblings}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Married Female Siblings")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.marriedFemaleSiblings}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Siblings Details")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.siblingsDetails}
                  </p>
                </div>
              </motion.div>

              {/* Divider */}
              <div className="hidden lg:block h-auto w-[1px] bg-primeColor"></div>

              {/* Contact Information */}
              <motion.div className="flex flex-col gap-5 w-full lg:w-fit px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Contact Information")}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Phone Number")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.isDownloaded || userDetails?._id === ownId
                      ? userDetails?.contactInformation?.mobileNumber
                      : "**********"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Email Id")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.isDownloaded || userDetails?._id === ownId
                      ? userDetails?.contactInformation?.email || "-"
                      : "**************"}
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Present Address")}</p>
                  <div className="text-xs sm:text-sm font-bold text-primeColor space-y-1 break-words">
                    {userDetails?.isDownloaded || userDetails?._id === ownId ? (
                      <>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.addressLine1 || "--"}
                        </p>
                        {userDetails?.contactInformation?.presentAddress
                          ?.addressLine2 && (
                          <p>
                            {
                              userDetails?.contactInformation?.presentAddress
                                ?.addressLine2
                            }
                          </p>
                        )}
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.city || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.district || "--"}{" "}
                          -{" "}
                          {userDetails?.contactInformation?.presentAddress
                            ?.pinCode || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.presentAddress
                            ?.state || "--"}
                        </p>
                      </>
                    ) : (
                      <p>{"**********************"}</p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Native Address")}</p>
                  <div className="text-xs sm:text-sm font-bold text-primeColor space-y-1 break-words">
                    {userDetails?.isDownloaded || userDetails?._id === ownId ? (
                      <>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.addressLine1 || "--"}
                        </p>
                        {userDetails?.contactInformation?.nativeAddress
                          ?.addressLine2 && (
                          <p>
                            {
                              userDetails?.contactInformation?.nativeAddress
                                ?.addressLine2
                            }
                          </p>
                        )}
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.city || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.district || "--"}{" "}
                          -{" "}
                          {userDetails?.contactInformation?.nativeAddress
                            ?.pinCode || "--"}
                        </p>
                        <p>
                          {userDetails?.contactInformation?.nativeAddress
                            ?.state || "--"}
                        </p>
                      </>
                    ) : (
                      <p>{"**********************"}</p>
                    )}
                  </div>
                </div>
              </motion.div>

              {/* Divider */}
              <div className="hidden lg:block h-auto w-[1px] bg-primeColor"></div>

              {/* Expected Information */}
              <motion.div className="flex flex-col flex-wrap gap-5 w-full lg:w-fit no-print px-2 py-2">
                <p className="text-lg font-bold text-primeColor">
                  {t("Expected Information")}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Income")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.additionalInformation?.expectedSalary || "--"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Status")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.additionalInformation?.expectedStatus
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedStatus?.map(
                          (c, i) => (
                            <span key={i}>
                              {getStatus(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedStatus?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Zodiac Signs")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.additionalInformation?.expectedZodiacSigns
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedZodiacSigns?.map(
                          (c, i) => (
                            <span key={i}>
                              {getZodiac(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedZodiacSigns?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Stars")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.additionalInformation?.expectedStars?.length >
                    0
                      ? userDetails?.additionalInformation?.expectedStars?.map(
                          (c, i) => (
                            <span key={i}>
                              {getStars(c)}
                              {i !==
                                userDetails?.additionalInformation
                                  ?.expectedStars?.length -
                                  1 && ", "}
                            </span>
                          )
                        )
                      : "--"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Expectations")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.additionalInformation?.expectation || "---"}
                  </p>

                  <p className="text-xs sm:text-sm font-medium">{t("Asset Information")}</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.familyInformation?.assetInfo}
                  </p>
                </div>
              </motion.div>
            </motion.div>
            <motion.div className="flex flex-col gap-6 sm:gap-8 w-full px-2 sm:px-5 py-4 sm:py-6 relative">
              <p className="text-xl font-bold text-primeColor">
                {t("Birth Information")}
              </p>

              {/* Responsive wrapper */}
              <motion.div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-6">
                {/* Individual Info Blocks */}
                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Birth Time")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {formatTo12Hour(userDetails?.birthTime)}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Birth Place")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.birthPlace}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Dhisai Iruppu")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {getDhisas(userDetails?.thisaiIruppu) || "-"}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Dhisai Iruppu Date")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.thisaiIruppuDate}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Dhisai Iruppu Month")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.thisaiIruppuMonth}
                  </p>
                </motion.div>

                <motion.div className="grid w-full sm:w-[48%] lg:w-[31%] grid-cols-2 gap-3">
                  <p className="text-xs sm:text-sm font-medium">{t("Dhisai Iruppu Year")} :</p>
                  <p className="text-xs sm:text-sm font-bold text-primeColor break-words">
                    {userDetails?.thisaiIruppuYear}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            {
              <motion.div className="h-full flex flex-col md:flex-row min-w-screen py-4 justify-between child-wrapper md:px-20 gap-2 my-4">
                <div className="rasi-chart print:scale-[0.6] print:mt-4">
                  {!registration && (
                    <RasiKattam
                     kattamOuterInjectClass={`h-[300px] w-[300px] md:h-[400px] md:w-[400px]`}
                      kattamInnerInjectclass={
                        "h-[75px] w-[75px] md:h-[100px] md:w-[100px]"
                      }
                      readOnly={true}
                      rasiValues={userDetails?.rasiKattam?.rasiPlanets}
                    />
                  )}
                  {registration && (
                    <RasiKattam
                      kattamOuterInjectClass={`h-[400px] w-[400px]`}
                      kattamInnerInjectclass={"h-[100px] w-[100px]"}
                      rasiValues={userDetails?.rasiKattam}
                      readOnly={true}
                    />
                  )}
                </div>
                <div className="amsa-chart print:scale-[0.6] print:mt-4">
                  {!registration && (
                    <AmsaKattam
                      kattamOuterInjectClass={`h-[300px] w-[300px] md:h-[400px] md:w-[400px]`}
                      kattamInnerInjectclass={
                        "h-[75px] w-[75px] md:h-[100px] md:w-[100px]"
                      }
                      readOnly={true}
                      amsaValues={userDetails?.amsaKattam?.amsaPlanets}
                    />
                  )}
                  {registration && (
                    <AmsaKattam
                      kattamOuterInjectClass={`h-[400px] w-[400px]`}
                      kattamInnerInjectclass={"h-[100px] w-[100px]"}
                      amsaValues={userDetails?.amsaKattam}
                      readOnly={true}
                    />
                  )}
                </div>
              </motion.div>
            }
          </motion.div>
        </motion.div>
      )}
      <Dialog
        title={"Download Confirm"}
        showDialog={downloadConfirm}
        onClose={() => {
          setDownloadConfirm(false);
        }}
      >
        <motion.div className="h-full w-full flex flex-col gap-5 px-2 py-2">
          <p>Are you sure you want to download this profile?</p>
          <motion.div className="flex justify-center gap-2">
            <Button
              type="primary"
              disabled={confirmLoading}
              injectClass="rounded-md"
              onClick={() => !confirmLoading && confirmDownload()}
            >
              Yes
            </Button>
            <Button
              type="secondary"
              injectClass="rounded-md"
              onClick={() => {
                setDownloadConfirm(false);
              }}
            >
              No
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>
    </>
  );
};

export default PreviewUser;
